import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import ISpineWinSymbolViewConfig from '../../vendor_core/core/src/managers/contracts/configurations/ISpineWinSymbolViewConfig';
class SpineWinSymbolViewConfig implements ISpineWinSymbolViewConfig {
    type: ConfigurationTypes = ConfigurationTypes.WIN_SYMBOL_SPINE_ANIMATIONS;
    public preGenerateNumberOfSymbols: number = 3;
    public defaultID: number = 0;
}

export default new SpineWinSymbolViewConfig
